import * as React from "react";
import { useState } from "react";
import CabinetSelection from "../components/CabinetSelection";
import BaseModel from "../models/BaseModel";
import Room from "../models/Room";
import PropertyViewHeader from "./PropertyViewHeader";
import BaseDialog from "../modelDialogs/BaseDialog";
import { itx } from "../translationItx/itx";
import { ConnectionType } from "../models/Connection";

export default function RoomPropertyView(props: { obj: BaseModel; setPinned?: (pinned: boolean) => void }) {
  const { obj } = props;

  const room = obj as Room;

  const [cabinetId, setCabinetId] = useState(room?.cabinetId || "");
  async function changeConsumerActorConnection() {
    for (let [key, consumer] of room.consumers.items) {
      if (room.cabinet) {
        const todeleteConnection = consumer.connections.asArray().filter((con) => {
          return con.type == ConnectionType.Channel;
        });
        todeleteConnection.forEach((con) => con.delete());
        const createdObjects = room.cabinet.autoConnectChannel(room.getOrCreatePage(), consumer);
        createdObjects.forEach((createdObj) => {});
      }
    }
  }

  function AskIfConsumerActorConnectionShouldBeInNewCabinet(props: {}) {
    return (
      <BaseDialog
        onOk={() => {
          changeConsumerActorConnection();
          return true;
        }}
        title={itx("roomPropertyView.redirectConsumerConnectionToNewCabinet", "Neuen Schaltschrank verbinden")}
      >
        <div>
          {itx(
            "roomPropertyView.channelConnectionsToOldCabinet",
            "Alle Verbindungen zum aktuellen Schaltschrank werden getrennt.",
          )}
          <br />

          {itx(
            "roomPropertyView.shouldNewConnectionsBeCreated",
            "Es werden neue Verbindungen mit dem neuen Schaltschrank erstellt.",
          )}
        </div>
      </BaseDialog>
    );
  }

  return (
    <div key={obj.id} className="App PropertyView">
      <PropertyViewHeader obj={obj} />

      <div style={{ padding: "10px", display: "flex", flexDirection: "row", justifyContent: "center" }}>
        {state.translate("components.Cabinet", "Schaltschrank")}
        &nbsp;
        <CabinetSelection
          value={cabinetId}
          onChange={(id) => {
            const oldCabinet = room.cabinet;
            setCabinetId(id);
            room.cabinetId = id;
            if (oldCabinet != room.cabinet) {
              state.dialogManager.openDialog(<AskIfConsumerActorConnectionShouldBeInNewCabinet />);
            }
          }}
          onChangeAfterCreation={() => {
            state.dialogManager.openDialog(<AskIfConsumerActorConnectionShouldBeInNewCabinet />);
            return false;
          }}
          forRoom={true}
          floorRoom={room}
          fromProeprtyView={true}
        ></CabinetSelection>
      </div>
    </div>
  );
}
